var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "float": "left",
      "margin": "-40px 0 0 40px",
      "font-weight": "600"
    }
  }, [_vm._v("\n                工资申请单-" + _vm._s(_vm.ruleForm.id === null || _vm.ruleForm.id === '' ? '新增' : '修改'))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "height": "40px",
      "margin-top": "-40px",
      "margin-right": "40px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": _vm.Return
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "750px",
      "background-color": "white",
      "margin": "75px 40px 0 40px",
      "overflow-x": "hidden"
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "180px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-top": "80px",
      "width": "80%"
    },
    attrs: {
      "label": "类别",
      "prop": "dictionaries_id"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "595px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.ruleForm.dictionaries_id),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "dictionaries_id", $$v)
      },
      expression: "ruleForm.dictionaries_id"
    }
  }, _vm._l((_vm.$parent.dictionariesList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.data,
        "value": item.id
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    on: {
      "click": _vm.StaffFind
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "姓名",
      "prop": "staff_name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "595px"
    },
    attrs: {
      "onfocus": "this.blur();"
    },
    model: {
      value: (_vm.ruleForm.staff_name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "staff_name", $$v)
      },
      expression: "ruleForm.staff_name"
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "项目"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "595px"
    },
    model: {
      value: (_vm.ruleForm.project_name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "project_name", $$v)
      },
      expression: "ruleForm.project_name"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "时间",
      "prop": "current_date"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "595px"
    },
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期时间"
    },
    model: {
      value: (_vm.ruleForm.current_date),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "current_date", $$v)
      },
      expression: "ruleForm.current_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "原因",
      "prop": "reason"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "595px"
    },
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "请输入奖励/处罚原因"
    },
    model: {
      value: (_vm.ruleForm.reason),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "reason", $$v)
      },
      expression: "ruleForm.reason"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "金额",
      "prop": "money"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "595px"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入奖励/处罚金额"
    },
    model: {
      value: (_vm.ruleForm.money),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "money", $$v)
      },
      expression: "ruleForm.money"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "200px"
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ruleForm.id === null || _vm.ruleForm.id === ''),
      expression: "ruleForm.id === null || ruleForm.id === ''"
    }],
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ruleForm.id != null && _vm.ruleForm.id != ''),
      expression: "ruleForm.id != null && ruleForm.id != ''"
    }],
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.UpdateAuditor()
      }
    }
  }, [_vm._v("修改")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "addbtn"
    },
    on: {
      "click": function($event) {
        return _vm.resetForm('ruleForm')
      }
    }
  }, [_vm._v("重置")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择姓名",
      "visible": _vm.dialogVisible,
      "width": "40%",
      "center": true,
      "close-on-click-modal": false,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-row', [_c('organizeStaff', {
    ref: "organizeStaff",
    attrs: {
      "type": "checkbox",
      "accordion": true,
      "staff_ids_prop": _vm.ruleForm.staff_ids
    },
    on: {
      "commit": _vm.saveChange
    }
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.$refs['organizeStaff'].commit()
      }
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f35aa2e","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jcrsgl/Jcgl/Jcgl_add.vue
// module id = null
// module chunks = 